/*
 * tu-promo.js — TU Sales Boost behaviour (replaces Hextom)
 * Phase 1: refresh the "only X left" message + stock bar when the variant changes.
 * Later phases add: add-to-cart glow toggle, countdown ticking.
 */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.__tuPromoInit) return;
    root.__tuPromoInit = true;

    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 30;

    // Parse "variantId:qty,variantId:qty" (qty may be "null" when untracked)
    var qtyMap = {};
    (root.getAttribute('data-qty-map') || '').split(',').forEach(function (pair) {
      if (!pair) return;
      var i = pair.lastIndexOf(':');
      if (i === -1) return;
      var id = pair.slice(0, i);
      var raw = pair.slice(i + 1);
      qtyMap[id] = raw === 'null' ? null : parseInt(raw, 10);
    });

    // ── Feature #3: add-to-cart breathing glow ──
    if (root.getAttribute('data-show-glow') === 'true') {
      var accent = root.getAttribute('data-accent') || '#53B59B';
      document.querySelectorAll('.product-form__submit').forEach(function (btn) {
        btn.style.setProperty('--tu-accent', accent);
        btn.classList.add('tu-atc-glow');
      });
    }

    // ── Feature #3a: move the PDP image badge onto the main gallery image ──
    // Insert into the gallery WRAPPER, never into .product__media — Dawn's .media rule
    // stretches its children to fill the container (which blew the badge up full-size).
    var pdpBadge = root.querySelector('[data-tu-pdp-badge]');
    if (pdpBadge) {
      var host = document.querySelector('.product__media-wrapper')
              || document.querySelector('media-gallery')
              || document.querySelector('.product__media-list');
      if (host) {
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        host.appendChild(pdpBadge);
        pdpBadge.hidden = false;
      }
    }

    var stock = root.querySelector('[data-tu-stock]');
    if (!stock) return;
    var countEl = stock.querySelector('[data-tu-stock-count]');
    var fillEl = stock.querySelector('[data-tu-stock-fill]');

    function render(qty) {
      if (qty === null || isNaN(qty) || qty <= 0 || qty > threshold) {
        stock.hidden = true;
        return;
      }
      stock.hidden = false;
      if (countEl) countEl.textContent = qty;
      if (fillEl) {
        // Remaining stock as a % of threshold — bar empties as stock runs down.
        var fill = Math.round((qty / threshold) * 100);
        if (fill > 100) fill = 100;
        if (fill < 5) fill = 5;
        fillEl.style.width = fill + '%';
      }
    }

    function onVariant(variant) {
      if (!variant) return;
      var qty = qtyMap[String(variant.id)];
      render(typeof qty === 'undefined' ? null : qty);
    }

    // Dawn pub/sub (newer themes) ...
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.variant) onVariant(event.data.variant);
      });
    }
    // ... and the legacy DOM event, as a fallback.
    document.addEventListener('variant:changed', function (event) {
      if (event && event.detail && event.detail.variant) onVariant(event.detail.variant);
    });
  }

  // ── Feature #7: countdown timer ──
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  function setCard(card, ch) {
    if (card.textContent === ch) return;
    card.classList.remove('tu-flip');
    // force reflow so the animation can replay
    void card.offsetWidth;
    card.classList.add('tu-flip');
    setTimeout(function () { card.textContent = ch; }, 180); // swap at mid-flip
  }

  function initClock(clock) {
    if (clock.__tuClockInit) return;
    clock.__tuClockInit = true;

    var ts = parseInt(clock.getAttribute('data-deadline-ts'), 10);
    if (!ts) return;
    var deadline = ts * 1000;
    var row = clock.querySelector('[data-tu-clock-row]');
    var expired = clock.querySelector('[data-tu-clock-expired]');
    var groups = {};
    clock.querySelectorAll('.tu-clock__group').forEach(function (g) {
      groups[g.getAttribute('data-unit')] = g.querySelectorAll('.tu-clock__card');
    });

    function writeUnit(unit, value) {
      var cards = groups[unit];
      if (!cards) return;
      var s = pad2(value);
      setCard(cards[0], s.charAt(0));
      setCard(cards[1], s.charAt(1));
    }

    var intId;
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        if (intId) clearInterval(intId);
        if (row) row.hidden = true;
        var desc = clock.querySelector('.tu-clock__desc');
        if (desc) desc.hidden = true;
        if (expired) expired.hidden = false;
        return;
      }
      var s = Math.floor(diff / 1000);
      writeUnit('days', Math.floor(s / 86400));
      writeUnit('hours', Math.floor((s % 86400) / 3600));
      writeUnit('minutes', Math.floor((s % 3600) / 60));
      writeUnit('seconds', s % 60);
    }
    tick();
    intId = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-tu-promo]').forEach(initRoot);
    document.querySelectorAll('[data-tu-clock]').forEach(initClock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
